import { render, staticRenderFns } from "./AccordionTrigger.vue?vue&type=template&id=732910e1&scoped=true&"
import script from "./AccordionTrigger.vue?vue&type=script&lang=js&"
export * from "./AccordionTrigger.vue?vue&type=script&lang=js&"
import style0 from "./AccordionTrigger.vue?vue&type=style&index=0&id=732910e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732910e1",
  null
  
)

export default component.exports